var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M16.6 10.88L15.18 9.46L10.94 13.71L8.82 11.58L7.4 13L10.94 16.54L16.6 10.88Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }